'use strict';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {CurationEditorAbstract} from '../curation-editor-abstract';
import {WorkflowBarActionsCreatorService} from '@ispm/shared/components/workflow-bar/services/workflow-bar-actions-creator.service';
import {DynamicModalLoaderService} from '@ispm/layout/services/dynamic-modal-loader.service';
import {CurationActionCreatorService} from '../../../services/curation-action-creator.service';
import {FormHandlerService} from '@ispm/dynamic-form/services/form-handler.service';
import {CurationNodeSelectionSource, CurationPanels, CurationSettings} from '../../curation-dashboard/curation-setting';
import {PdfJsViewerComponent} from 'ng2-pdfjs-viewer';
import {flatten, get, has, isEmpty, set, values} from 'lodash';
import {Actions, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {State} from '@ispm-client/modules/bpmn-modeler/store/state';
import {
  ActiveNodeNotesPanelAction,
  AddNodeWithNotesAction,
  BpmnHooksActionTypes,
  BpmnProcessCreatorActionTypes, ChangeSelectedNode,
  DirectUpdateBpmnModelerDataAction,
  InitNodesWithNotesAction,
  NodeActionTypes,
  NodeOpenNotes,
  NodeUpdated,
  PreviewBpmn,
  RootNodeUpdatedName,
  SaveBpmn,
  SaveBpmnSuccess,
  SaveFailureAction,
  ValidateBpmn
} from '@ispm-client/modules/bpmn-modeler/store/actions';
import {PathwaysAuthoringState} from '@ispm/shared/constants/pathways-authoring-state';
import {Observable, Subject} from 'rxjs/Rx';
import {
  NavigateToNode,
  NavigateToNodeWithData
} from '@ispm-client/modules/bpmn-modeler/store/actions/node-navigator.action';
import {CurationUtils} from '../../../utils/curation-utils';
import {NodeType} from '@ispm/shared/bpmn-io/node-type';
import {ModelApprovalPanelService} from '@ispm-client/modules/bpmn-modeler/service/model-approval-panel.service';
import {PanelPosition} from '@ispm/layout/components/panel/panel.component';
import {CurationService} from '../../../services/curation.service';
import {BpmnModelerService} from '@ispm-client/modules/bpmn-modeler/service/bpmn-modeler.service';
import {EntityTreeService} from '@ispm/shared/services/entity-tree.service';
import {EntityTreeElement} from '@ispm-shared/modules/common/entity-tree-element';
import {PanelsService} from '@ispm/layout/services/panels.service';
import {
  CloseNotesPanelAction,
  NotesPanelActionTypes
} from "@ispm-client/modules/bpmn-modeler/store/actions/notes-panel.actions";
import {StartPreviewPathways} from "@ispm/test/store/preview/preview.actions";
import {CoreActionCreatorService} from "@ispm/core/services/core-action-creator.service";
import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";
import {TranslateService} from "@ngx-translate/core";
import {ConfirmModalComponent} from "@ispm/layout/components/modals/confirm-modal/confirm-modal.component";
import {ModalTypes} from "@ispm/layout/components/modals/contants/modal-types.enum";
import {catchError, take, takeUntil, tap} from 'rxjs/operators';
import {ClearUnsavedActions} from '@ispm-client/modules/bpmn-modeler/store/actions/user-initiated-actions.actions';
import {SearchService} from "@ispm/dynamic-form/services/search.service";
import {NodePanelConfigurationService} from '@ispm-client/modules/bpmn-modeler/service/node-panel-configuration.service';
import {UserActionCreatorService} from '@ispm/user/services/user-action-creator.service';
import {DiagnosticOrderService} from '@ispm/dashboard/test/services/diagnostic-order.service';
import {ActivityService} from '@ispm/user/services/activity.service';
import {AuthenticationService} from '@ispm/user/services/authentication.service';
import {WorkflowConfigService} from "@ispm/workflow/services/workflow-config.service";
import {NotesService} from '@ispm/user/services/notes.service';
import {NotificationMessageService} from '@ispm/core/components/customise-notification/notifications-message.service';
import {ActivatedRoute, Router} from "@angular/router";
import {ErrorMessages} from "@ispm/shared/constants/error-messages";
import {HttpInterceptorService} from "@ispm/core/services/http-interceptor.service";
import {TreeViewPanelService} from '@ispm-client/modules/bpmn-modeler/service/tree-view-panel.service';
import {PathwayJsonTreeConverterService} from '../../../services/pathway-json-tree-converter.service';
import {NodesPlaceViewCalculationsService} from '../../../services/nodes-place-view-calculations.service';
import {RouterManagerService} from "@ispm/core/services/router-manager.service";
import {LogService} from "@ispm/core/services/log.service";

@Component({
  selector: 'gen-curation-pathways-bpmn',
  templateUrl: 'curation-pathways-bpmn.component.html',
  styleUrls: ['curation-pathways-bpmn.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})

export class CurationPathwaysBpmnComponent extends CurationEditorAbstract implements OnInit, OnDestroy {
  private DEFAULT_RIGHT_PANEL_WIDTH = 574;
  private DEFAULT_SHIFT_FROM_RIGHT_PANEL = 32;

  private readonly prefetchFormForPathwaysCuration = ['GUIDANCE_NOTES-CURATOR'];
  @ViewChild('inlinePdfViewer', {static: false}) public inlinePdfViewer: PdfJsViewerComponent;
  public formName: string;
  public bpmnModelerCfg: any;
  public performTreeRepair: string;
  public modelApprovalCfg: any;
  public pendingForApproval: boolean = false;
  pdfFileNotUploaded = true;
  showPdfViewer = false;
  isWithReport = true;
  bpmnCurationStatus;
  _bpmnState: PathwaysAuthoringState;
  visible: boolean = true;
  private statusChangedToRevise: boolean = false;
  protected destroyer$: Subject<null> = new Subject();
  private previousStatus: string;
  public hideBpmnLogo: boolean = true;
  public nodesWithNotes: {id: string; name: string}[] = [];
  private isModelerReady: boolean = false;
  private nodeIdsWithNotes: string[];
  private showListOfNodesWithNotes: boolean;
  private notesPerNode: Map<string, any> = new Map<string, any>();

  public showApproveContainer:boolean = true;
  public bpmnApprovalPanel = ModelApprovalPanelService.BpmnApprovalPanelName;
  public bpmnApprovalPanelPosition = PanelPosition.LEFT;

  public showTreeViewContainer: boolean = false;
  public bpmnTreeViewPanel = TreeViewPanelService.BpmnTreeViewlPanelName;
  public bpmnTreeViewPanelPosition = PanelPosition.LEFT;
  public treeViewConfig:any;

  public discipline:string = "1";
  private subscription;
  private latestSelectionSource: CurationNodeSelectionSource = CurationNodeSelectionSource.modelerView;
  private explorerViewIsVisible: boolean = false;
  private explorerViewIsInExpandedState: boolean = false;
  private selectedNodeId: any = undefined;
  private explorerViewNodeStateMap: Map<string, boolean> = new Map<string, boolean>();

  constructor(public authService: AuthenticationService,
              formHandler: FormHandlerService,
              public notificationMessageService: NotificationMessageService,
              private curationService: CurationService,
              private bpmnModelerService: BpmnModelerService,
              workflowBarActionsCreatorService: WorkflowBarActionsCreatorService,
              modalLoader: DynamicModalLoaderService,
              activatedRoute: ActivatedRoute,
              panelService: PanelsService,
              curationActionCreatorService: CurationActionCreatorService,
              actions$: Actions,
              private store$: Store<State>,
              private genomicsStore: Store<IgenomicsState>,
              private modelApprovalPanelService: ModelApprovalPanelService,
              private entityTreeService: EntityTreeService,
              notesService: NotesService,
              coreAC: CoreActionCreatorService,
              translateService: TranslateService,
              protected diagnosticOrderService: DiagnosticOrderService,
              detector: ChangeDetectorRef,
              private nodePanelConfigurationService: NodePanelConfigurationService,
              private searchService: SearchService,
              public userActionCreatorService: UserActionCreatorService,
              public activityService: ActivityService,
              workflowConfigService: WorkflowConfigService,
              _http: HttpInterceptorService,
              public treeViewPanelService: TreeViewPanelService,
              private pathwayDataConverter: PathwayJsonTreeConverterService,
              private nodesPlaceViewCalculationsService: NodesPlaceViewCalculationsService,
              private logService: LogService,
              router: Router,
              routerManagerService: RouterManagerService) {
    super(authService, formHandler, notificationMessageService, workflowBarActionsCreatorService, modalLoader,
      activatedRoute, panelService, notesService, coreAC, curationActionCreatorService, translateService,
      diagnosticOrderService, userActionCreatorService, activityService, _http, router, undefined, detector, workflowConfigService, routerManagerService);
    this.subscribeToModelerActions(actions$);
  }

  get bpmnState(): PathwaysAuthoringState {
    return this._bpmnState;
  }

  get disease(): string {
    return this.content ? this.content['disease']['display'] : undefined;
  }

  get pathwayBpmnName(): string {
    if(this.content){
      return get(this.content,CurationSettings.PATHWAYBPMN_NAME,this.disease);
    }
    return undefined;
  }

  set pathwayBpmnName(name : string){
    if (name){
      set(this.content, CurationSettings.PATHWAYBPMN_NAME, name);
    }
  }

  get getbpmnCurationStatus(): string {
    return this.bpmnCurationStatus;
  }

  ngOnInit() {
    super.ngOnInit();
    this.searchService.toggleIncludeSearchTermForCache();
    this.preFetchForms(this.prefetchFormForPathwaysCuration);
    this.nodePanelConfigurationService.initUnsavedUserActions();
    this.selectedNodeId = undefined;
  }

  ngOnDestroy() {
    this.store$.dispatch(new ClearUnsavedActions());
    this.searchService.toggleIncludeSearchTermForCache();
    super.ngOnDestroy();
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private loadNodeSpecificNotes() {
    this.notesService.getWithContextType(this.currentRevisionId, "NodeRevision", this.actorId, true).toPromise().then((res) => {
      if (res) {
        const nodeNotes = res.body;
        this.nodeIdsWithNotes = [];
        if (nodeNotes) {
          nodeNotes.forEach((note) => {
            const nodeId: string = this.getNodeIdContext(note);
            if (nodeId) {
              this.addNoteToNodeMap(nodeId, note);
              if (!this.nodeIdsWithNotes.includes(nodeId)) {
                this.nodeIdsWithNotes.push(nodeId);
              }
            }
          });
        }
        this.store$.dispatch(new InitNodesWithNotesAction({ nodeIds: new Set(this.nodeIdsWithNotes) }));
        this.updateNodesWithNotesIfReady();
      }
    });
  }

  private addNoteToNodeMap(nodeId: string, note) {
    let notesForThisNode: any[] = this.notesPerNode.get(nodeId);
    if (!notesForThisNode) {
      notesForThisNode = [];
      this.notesPerNode.set(nodeId, notesForThisNode);
    }
    notesForThisNode.push(note);
  }

  private updateNodesWithNotesIfReady() {
    if (this.nodeIdsWithNotes && this.isModelerReady) {
      this.removeNotesOfUnsavedNodes().then(  // Remove notes that were saved before their nodes were saved (as part of the pathway curation item)
        r => {
          if (this.showListOfNodesWithNotes) {
            let nodeMap: { id: string; name: string }[] = [];
            this.nodeIdsWithNotes.forEach(nodeId => nodeMap.push(this.getNodeMapElement(nodeId)));
            this.nodesWithNotes = nodeMap;
          }
        }
      );
    }
  }

  private removeNotesOfUnsavedNodes(): Promise<any> {
    if (isEmpty(this.nodeIdsWithNotes)) {
      return Promise.resolve(null);
    }
    const nodeIdsWithNotesToRemove = this.nodeIdsWithNotes.filter(nodeId => !this.bpmnModelerService.getNode(nodeId));
    if (isEmpty(nodeIdsWithNotesToRemove)) {
      return Promise.resolve(null);
    }
    let updates: Promise<any>[] = [];
    nodeIdsWithNotesToRemove.forEach(nodeId => {
      const notesToRemove: any[] = this.notesPerNode.get(nodeId);
      notesToRemove.forEach(note => updates.push(this.removeNote(note)));
    });
    this.nodeIdsWithNotes = this.nodeIdsWithNotes.filter(nodeId => !nodeIdsWithNotesToRemove.includes(nodeId));
    return Promise.all(updates);
  }

  private removeNote(note): Promise<any> {
    if (note.context) {
      note.context.forEach(contextRef => contextRef.reference = "old." + contextRef.reference);
    }
    // 'actor' property is flattened when the note is read from the backend. Replace it back with the reference.
    if (note.actor && note.actor.id) {
      note.actor = {
        "reference": note.actor.id,
        "resourceType": "Practitioner"
      };
    }
    return this.notesService.update(note);
  }

  private getNodeMapElement(nodeId: string) {
    return {id: nodeId, name: this.bpmnModelerService.getNodeName(nodeId)};
  }

  private getNodeIdContext(note: any) {
    const nodeContext = note.context.find((context) => context.resourceType === "NodeId");
    return nodeContext ? nodeContext.reference : null;
  }

  postGetCurationItem() {
    this.renderPdf(this.content);
    this.pendingForApproval = this.curationStatus == CurationSettings.CURATION_STATUS_WAITING_FOR_APPROVAL;
    this.isDataLoaded = true;
    this.detector.detectChanges();
  }

  postUpdateCurationItem() {
    this.updateForm(this.content);
    this.updateForm(this.curationItem.curationData['content']);
  }

  private closeNotesPanel() {
    this.hideNotesPanel();
  }

  private setActiveNodeNotesPanel(nodeId) {
    this.store$.dispatch(new ActiveNodeNotesPanelAction({nodeId}));
  }

  private nodeOpenNotes(node: any) {
    const nodeId: string = node.id;
    this.setActiveNodeNotesPanel(nodeId);
    this.showNotesPanel(this.getNodeNotesTitle(node), nodeId, (note) => this.notesAddedToNode(nodeId, note));
  }

  private notesAddedToNode(nodeId: string, note: any) {
    this.store$.dispatch(new AddNodeWithNotesAction({ nodeId: nodeId }));
    if (this.showListOfNodesWithNotes) {
      // If nodeId is already in the list, move it to the top; otherwise, just add it at the top.
      let nodes = this.nodesWithNotes.filter(element => element.id !== nodeId);
      this.nodesWithNotes = [this.getNodeMapElement(nodeId), ...nodes];
    }
  }

  private refreshNodesWithNotes(id: string, name: string) {
    if (this.showListOfNodesWithNotes) {
      this.nodesWithNotes = this.nodesWithNotes.map((node) =>
        (node.id === id) ? { id, name } : node);
    }
  }

  private getNodeNotesTitle(node: any): string {
    return "Notes - " + node.id;
  }

  public toggleDisplayStatusChanged(display: boolean) {
    super.toggleDisplayStatusChanged(display);
    if (!display) {
      this.setActiveNodeNotesPanel(null);
    }
  }

  public toggleNotesPanel(title?: string) {
    super.toggleNotesPanel(title);
    this.setActiveNodeNotesPanel(null);
  }

  setInitParams() {
    if (!CurationSettings.CURATION_EDITOR_WITH_REPORT.includes(this.curationType)) {
      this.isWithReport = false;
    }
    if (!!this.curationData) {
      this.discipline = get(this.curationData, 'content.discipline.code', undefined);
    }

    this.formName = this.conf['ui']['forms']['editorForms']['formName'].name;
    this.bpmnModelerCfg = get(this.conf, 'ui.bpmnModeler', undefined);
    this.performTreeRepair = get(this.conf, 'ui.performTreeRepair', false);
    this.revisiedEntitiesTableData.columns = get(this.conf, 'ui.revisiedEntitiesTable.columns');
    this.revisiedEntitiesTableData.rowData = get(this.conf, 'ui.revisiedEntitiesTable.rowData');

    this.modelApprovalCfg = get(this.conf, 'ui.modelApproval', undefined);
    this.hideBpmnLogo = get(this.conf, 'ui.hideBpmnLogo', true);

    const showListOfNodesWithNotes = get(this.conf, 'ui.showListOfNodesWithNotes', true);
    this.showListOfNodesWithNotes = !(showListOfNodesWithNotes === false);

    if (!this.bpmnModelerCfg['behavior'] || this.bpmnModelerCfg['behavior']['allowNotesPerNode'] !== false) {
      this.loadNodeSpecificNotes();
    }
    this.showApproveContainer = get(this.conf, 'ui.readOnly', true);

    this.treeViewConfig = get(this.conf, 'ui.treeView', undefined);
    this.showTreeViewContainer = this.isPublishedStatus(this.curationStatus) && !!this.treeViewConfig && !!this.bpmnModelerCfg;
    this.nodesPlaceViewCalculationsService.defaultRightPanelWidth = get(this.treeViewConfig, 'defaultRightPanelWidth', this.DEFAULT_RIGHT_PANEL_WIDTH);
    this.nodesPlaceViewCalculationsService.shiftFromRightPanel = get(this.treeViewConfig, 'shiftFromRightPanelPix', this.DEFAULT_SHIFT_FROM_RIGHT_PANEL);

    this.curationActionCreatorService.getState(['definitions'])
      .take(1)
      .subscribe((data => {
        this.confMap = Array.from(data.values()).filter(data => data['type'] === 'curationKB');

      }));
  }

  prepareDataToSave(status: string): Promise<boolean> {
    const treatmentPlansData = this.getTreatmentPlansData();
    const confRoot = this.confMap.filter(data => data['type'] === CurationSettings.CURATION_KB)[0];
    if (this.curationData) {
      CurationUtils.updateRelatedEntities(confRoot, this.curationData, treatmentPlansData);
       this.validateContent(status);
    }
    return Promise.resolve(true);
  }

  public getCurationKey(): string {
    let key: string;

    switch (this.curationType) {
      case CurationSettings.CURATION_PATHWAY_BPMN:
        key = this.pathwayBpmnName;
        break;
    }
    return key;
  }

  updateForm(form) {
    if (form) {
      // check if file was updated
      if (form.file && form.file.referenceId && (this.content === undefined ||
        this.content['file'] === undefined ||
        this.content['file']['referenceId'] != form.file.referenceId)) {
        this.renderPdf(form);
      }

      // in case file was deleted
      if (form.file && form.file === 'deleted') {
        this.showPdfViewer = false;
        this.pdfFileNotUploaded = true;
      }

      for (const prop in form) {
        this.content[prop] = form[prop];
      }
      this.curationKey = this.getCurationKey();
    }
  }

  renderPdf(content: any) {
    if (get(content, 'file.referenceId')) {
      this.pdfFileNotUploaded = false;
      this.curationActionCreatorService.getDownloadedFile(content.file.referenceId).pipe(takeUntil(this.destroyer$)).subscribe(
        (data => {
            /** Load the PDF file into the PDF viewer */
            this.inlinePdfViewer.pdfSrc = this.converBase64toBlob(data.base64Data);
            this.inlinePdfViewer.refresh();
            this.pdfFileNotUploaded = true;
            this.showPdfViewer = true;
          }
        ));
    }
  }

  validationEvent(valid) {
    this.isValid = valid;
  }

  private  updateStatusCallback(param) {
    this.setLoadingState(true);
    this.previousStatus = this.curationStatus;
    this.pdfFileNotUploaded = false;
    this.bpmnCurationStatus = param[0];
    const callback = param[1];

    if ((this.statusChangedToRevise = this.isStatusChangedFromReadToWrite(this.bpmnCurationStatus)) || this.isInReviewStatus(this.curationStatus)) {
      super.changeStatus(this.bpmnCurationStatus, callback);
    } else {

      if (has(this.curationData, CurationSettings.CONTENT_PATHWAYBPMN_NAME)) {
        this.testDuplicatedNameAndStore(this.bpmnCurationStatus, callback);
      } else {
        this.store$.dispatch(new SaveBpmn({
          deployAsFinal: this.shouldDeployAsFinal(this.bpmnCurationStatus),
          onSuccess: callback
        }));
      }
      // super change status will be called when save is done, by SAVE_BPMN_SUCCESS action
    }
  }

  async changeStatus(status: string, callback?: any) {
    this.nodePanelConfigurationService.isNodeContentChanged(null, this, this.updateStatusCallback, [status, callback]);
  }

  private testDuplicatedNameAndStore(status: string, callback: any) {
    const pathwayBpmnName = get(this.curationData, CurationSettings.CONTENT_PATHWAYBPMN_NAME);
    // check if there are duplicated items
    this.curationActionCreatorService.searchCurationInfoWithFilter(
      {
        query: {
          pathwayBpmnName: pathwayBpmnName,
          kb: this.curationActionCreatorService.getDb(),
          // Here we need properties that have dots in their name - e.g. 'content.pathwayBpmnName'. The '[' prefix is used to retrieve these, instead of nested proeprties.
          _fieldslist: '[' + CurationSettings.CONTENT_PATHWAYBPMN_NAME + ",[" + CurationSettings.CONTENT_DISCIPLINE_CODE + ",[" + CurationSettings.CONTENT_DISEASE_CODE,
          latest: true
        },
        type: get(this.curationData, 'content.type', undefined)
      }, true)
      .pipe(
        takeUntil(this.destroyer$),
        catchError(error => {
          this.setLoadingState(false);
          this.modalLoader.popupModal(ConfirmModalComponent,
            {
              title: 'Error',
              content: `Failed to save pathway (${ErrorMessages.PATHWAY_NAME_UNIQUENESS_VERIFICATION}). Please try again later.`,
              approveBtn: 'Close',
              declineBtn: ''
            }, ModalTypes.ALERT).pipe(takeUntil(this.destroyer$)).subscribe((response) => {});
          return Observable.throwError(error);
        })).subscribe(res => {
        // analyze results
          this.setLoadingState(false);
          if (Array.isArray(res) && res.length > 0 && this.findDuplicated(res)) {
            // show warning
            const discipline = get(this.curationData, CurationSettings.CONTENT_DISCIPLINE_DISPLAY, '');
            const message = `PathwayBpmn with ${pathwayBpmnName} name for ${discipline} already exists`;
            this.modalLoader.popupModal(ConfirmModalComponent,
              {
                title: 'Error',
                content: message,
                approveBtn: 'Close',
                declineBtn: ''
              }, ModalTypes.ALERT).pipe(takeUntil(this.destroyer$)).subscribe((response) => {
            });
          } else {
            this.setLoadingState(true);
            this.store$.dispatch(new SaveBpmn({
              deployAsFinal: this.shouldDeployAsFinal(status),
              skipValidation: !this.shouldDeployAsFinal(status),
              onSuccess: callback
            }))
          }
      });
  }

  private findDuplicated(curationInfos) {
    const curationBpmnName = get(this.curationData, CurationSettings.CONTENT_PATHWAYBPMN_NAME);
    const curationDiscipline = get(this.curationData, CurationSettings.CONTENT_DISCIPLINE_CODE);
    const curationDisease = get(this.curationData, CurationSettings.CONTENT_DISEASE_CODE);
    return curationInfos.some(item => {
         let name = item.hasOwnProperty(CurationSettings.CONTENT_PATHWAYBPMN_NAME) ? item[CurationSettings.CONTENT_PATHWAYBPMN_NAME]: undefined;
         let discipline = item.hasOwnProperty(CurationSettings.CONTENT_DISCIPLINE_CODE) ? item[CurationSettings.CONTENT_DISCIPLINE_CODE]: undefined;
         let disease = item.hasOwnProperty(CurationSettings.CONTENT_DISEASE_CODE) ? item[CurationSettings.CONTENT_DISEASE_CODE]: undefined;
         if(curationDiscipline === discipline) {
           if(name === curationBpmnName)
             return curationDisease === disease ? false: true;
         }
         return false;
    });
  }


  isStatusChangedFromReadToWrite(status) {
    return this.isPublishedStatus(this.curationStatus) && status === CurationSettings.CURATION_STATUS_DRAFT ||
      this.curationStatus === CurationSettings.CURATION_STATUS_REJECTED && status === CurationSettings.CURATION_STATUS_DRAFT;
  }

  calculateState(afterReassign : boolean = false): void {
    super.calculateState();
    this.calcTreeState();
    this.reloadModelerComponent(afterReassign);
  }

  nodeLinkClicked(event: any) {
    if (event && event.nodeId) {
      this.store$.dispatch(new NavigateToNode({nodeId: event.nodeId, openPanel: true}));
      if (event.params && event.params.showNotes) {
        this.store$.dispatch(new NodeOpenNotes({ node: this.bpmnModelerService.getNode(event.nodeId) }))
      }
    }
  }

  updateRevisedRelatedEntitiesTableData() {
    const pathwayBpmnNodes = this.content['bpmn'] ? (this.content['bpmn'].nodes || []) : [];
    this.revisedRelatedEntities.forEach((entity) => {
      values(pathwayBpmnNodes)
        .filter(node => node.type === NodeType.treatment)
        .filter(node => !isEmpty(node.data))
        .forEach((node) => {
          const treatmentPlansData = node.data['treatmentPlans'];
          const revisedTreatmentsNodeData = treatmentPlansData.filter((treatmentPlanItem) =>
            entity.relatedEntityId === treatmentPlanItem.treatmentPlan.relatedEntityId);
          this.appendDataToRevisedRelatedEntitiesTable(revisedTreatmentsNodeData, node);
        });
    });
  }

  private goBackCallback() {
      super.goBack(true);
  }

  goBack() {
    this.nodePanelConfigurationService.handleUnsavedChanges().pipe(
      take(1)
    ).subscribe(changesExist => {
      if (!changesExist) {
        this.nodePanelConfigurationService.isNodeContentChanged(null, this, this.goBackCallback);
      } else {
        super.goBack(true);
      }
    })
  }

  private submitCurationItemForReviewCallback() {
    //timer solves the issue when two dialogs should be opened one after another (unsaved changes dlg and submit for review dlg);
    //in this case subscribeList is missing appropriate item, see dynamic-modal-loader.service.ts, popupModal() method
    const tmr = setTimeout(() => {
      super.submitCurationItemForReview();
      clearTimeout(tmr);
    });
  }

  submitCurationItemForReview() {
    this.nodePanelConfigurationService.isNodeContentChanged(null, this, this.submitCurationItemForReviewCallback);
  }

  openModelApprovalPanel() {
    this.modelApprovalCfg.shiftUsed = this.isPublishedStatus(this.curationStatus);
    this.modelApprovalPanelService.openApprovalPanel(this.modelApprovalCfg, (this.content['modelApproval'] || {}),
      this.onModelApprovalChanged.bind(this));
  }

  // we don't know maybe this place is not right ...
  openTreeViewerPanel(){
    if (this.explorerViewIsVisible) {
      this.treeViewPanelService.closePanel();
    } else {
      const collapsedData = this.pathwayDataConverter.convertDataToTreeNodes(get(this.curationData, 'content.bpmn'),
        get(this.curationData, 'content.pathwayBpmnName'), false);
      const expandedData = this.pathwayDataConverter.convertDataToTreeNodes(get(this.curationData, 'content.bpmn'),
        get(this.curationData, 'content.pathwayBpmnName'), true);
      this.treeViewPanelService.openTreeViewPanel(this.treeViewConfig, {
        showExpanded: this.explorerViewIsInExpandedState,
        collapsedData: collapsedData,
        expandedData: expandedData,
        nodesStateMap: this.explorerViewNodeStateMap
      }, this.onTreeViewCommand.bind(this));
      this.store$.dispatch(new ChangeSelectedNode({nodeId: this.selectedNodeId, type: NodeType.head, parent: undefined}));
    }
  }

  onModelApprovalChanged(result) {
    if (result) {
      this.content['modelApproval'] = result;
    }
    this.modelApprovalPanelService.closePanel();
  }

  onModelerRender(isModelerRendered) {
    if (isModelerRendered) {
      this.triggerNodeUpdate();
      this.isModelerReady = true;
      this.updateNodesWithNotesIfReady();
    }
  }

  onNodeSelected($event) {
    const bpmnNodes = get(this.curationItem.curationData, 'content.bpmn.nodes', {});
    this.selectedNodeId = get($event, 'element.id', '');
    const foundNodeData = get(bpmnNodes, this.selectedNodeId);
    const payload = {
      nodeId: this.selectedNodeId,
      type: get(foundNodeData, 'type', 0),
      parent: get(foundNodeData, 'parentNodeIds', []).length > 0 ? get(foundNodeData, 'parentNodeIds', [])[0] : ''
    };
    this.store$.dispatch(new ChangeSelectedNode(payload));
    this.latestSelectionSource = CurationNodeSelectionSource.modelerView;
  }

  // Returns array of in use related entities (treamtent plans) ids
  public getCurrentRelatedEntitiesIds(): Array<string> {
    const treatmentPlansData = this.getTreatmentPlansData();
    const tpItemsArray = [];
    if (treatmentPlansData) {
      treatmentPlansData.map(item => item['treatmentPlan']).forEach(item => {
        if (!tpItemsArray.includes(item.code)) {
          tpItemsArray.push(item.code);
        }
      });
    }
    return tpItemsArray;
  }

  public getShowPreviewButton(){
     return this.showPreviewButton;
  }

  startPreview() {
    this.setLoadingState(true);
    this.store$.dispatch(new ValidateBpmn({
      curationStatus: this.curationStatus
    }));
  }

  private triggerNodeUpdate() {
    const updateNodeObj = this.curationService.getNodeUpdate();
    if (updateNodeObj) {
      this.bpmnModelerService.updateNode(updateNodeObj.getNodeId());
      this.setLoadingState(true);
      this.store$.dispatch(new SaveBpmn({
        deployAsFinal: false,
        skipValidation: true
      }));
      this.curationService.setNodeUpdate(null);
    }
  }

  private subscribeToModelerActions(actions$) {
    actions$
      .pipe(ofType<SaveBpmnSuccess>(BpmnProcessCreatorActionTypes.SAVE_BPMN_SUCCESS),
      takeUntil(this.destroyer$.asObservable()),
      tap(() => this.store$.dispatch(new ClearUnsavedActions())))
      .subscribe((res: SaveBpmnSuccess) => {
        set(this.curationItem, 'curationData.content.bpmn', res.payload.data);
        const hasProcessDefinitionID = !!get(this.curationItem, "curationData.content.bpmn.bpmnIdentifier.processId");
        if(this.shouldDeployAsFinal(this.getbpmnCurationStatus)){
          if(hasProcessDefinitionID){
            set(this.curationItem, 'curationData.content.readyForRun', res.payload.data.readyForRun);
            set(this.curationItem, 'curationData.content.bpmn.floatedNodes',{});
            super.changeStatus(this.getbpmnCurationStatus, res.payload.onSuccess);
          }
        } else {
          super.changeStatus(this.getbpmnCurationStatus, res.payload.onSuccess);
        }
        this.pdfFileNotUploaded = true;

      });
    actions$
      .pipe(ofType<PreviewBpmn>(BpmnProcessCreatorActionTypes.PREVIEW_BPMN))
      .takeUntil(this.destroyer$.asObservable())
      .subscribe((res) => {
        if (res) {
          if (this.curationStatus === CurationSettings.CURATION_STATUS_DRAFT) {
            const data = this.buildCurationData(this.curationStatus, this.getRejectMessage(this.curationStatus));
            set(this.curationItem, 'curationData.content.bpmn', res.payload);
            set(this.curationItem, 'curationData.content.readyForRun', res.payload.readyForRun);
            set(this.curationItem, 'curationData.content.bpmn.floatedNodes',{});
            this.updateCurationItemToPromise(this.curationStatus, data).then((res) => {
              if (res) {
                this.store$.dispatch(new StartPreviewPathways({
                  runPreviewMode: this.conf['runPreview'],
                  curationData: this.curationData,
                  curationStatus: this.curationStatus,
                  knowledgeBase: this.getDbName()
                }));
              }
            });
          } else {
              this.setLoadingState(false);
              this.store$.dispatch(new StartPreviewPathways({
              runPreviewMode: this.conf['runPreview'],
              curationData: this.curationData,
              curationStatus: this.curationStatus,
              knowledgeBase: this.getDbName(),
            }));
          }
        }
      });
    actions$
      .pipe(ofType<SaveFailureAction>(BpmnProcessCreatorActionTypes.SAVE_BPMN_FAILURE))
      .takeUntil(this.destroyer$)
      .subscribe((res: SaveFailureAction) => {
        if(this.readyForRun){
          const data = this.buildCurationData(this.curationStatus, this.getRejectMessage(this.curationStatus));
          set(this.curationItem, 'curationData.content.readyForRun', false);
          this.updateCurationItemToPromise(this.curationStatus, data).then((resCuration) => {
            this.notificationMessageService.error(`Error saving pathway bpmn curation item - ${res.payload.error}`);
          });
        } else {
            this.setLoadingState(false);
            this.notificationMessageService.error(`Error saving pathway bpmn curation item - ${res.payload.error}`);
        }

      });
    actions$
      .pipe(ofType<DirectUpdateBpmnModelerDataAction>(BpmnHooksActionTypes.DIRECT_UPDATE_BPMN_MODELER_DATA))
      .takeUntil(this.destroyer$)
      .subscribe((res: DirectUpdateBpmnModelerDataAction) => {
        const originalData = get(this.curationItem, 'curationData.content.bpmn');
        let bpmnModelerDataToUpdate = {...originalData, ...res.payload.bpmnModelerData};
        set(this.curationItem, 'curationData.content.bpmn', bpmnModelerDataToUpdate);
        const curationDataResource = this.curationItem.curationData;
        const curationDataElement: EntityTreeElement = {
          id: '',
          data: '',
          meta: {
            lastUpdated: '',
            versionId: '',
            created:'',
          },
          context: [],
          resourceType: ''
        };
        Object.assign(curationDataElement, curationDataResource);
        this.entityTreeService.update('CurationData', curationDataElement).pipe(takeUntil(this.destroyer$))
          .subscribe(
            res => {
              this.notificationMessageService.success('Updated Dependencies Map');
            },
            err => {
              this.notificationMessageService.error('Failed to Update Dependencies Map');
            }
          );
      });
    actions$
      .pipe(ofType<NodeOpenNotes>(NodeActionTypes.NODE_OPEN_NOTES))
      .takeUntil(this.destroyer$)
      .subscribe((res: NodeOpenNotes) => {
        this.nodeOpenNotes(res.payload.node);
      });
    actions$
      .pipe(ofType<CloseNotesPanelAction>(NotesPanelActionTypes.CLOSE_NOTES_PANEL))
      .takeUntil(this.destroyer$)
      .subscribe((res: CloseNotesPanelAction) => {
        this.closeNotesPanel();
      });
    actions$
      .pipe(ofType<NodeUpdated>(NodeActionTypes.NODE_UPDATED))
      .takeUntil(this.destroyer$)
      .subscribe((res: NodeUpdated) => {
        if (res.payload.data) {
          this.refreshNodesWithNotes(res.payload.id, res.payload.data.name);
        }
      });
    actions$
      .pipe(ofType<RootNodeUpdatedName>(NodeActionTypes.ROOT_NODE_NAME_UPDATED))
      .takeUntil(this.destroyer$)
      .subscribe((res: any) => {
        this.pathwayBpmnName = res.payload;
        this.curationKey = this.getCurationKey();
      });
  }

  private converBase64toBlob(base64Content: string): Blob {
    const byteCharacters = atob(base64Content);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    return new Blob([byteArray], {type: 'application/pdf'});
  }

  private isCurrentStateIsRevise(): boolean {
    return this.isEditableStatus(this.curationStatus) && this.revisionCount > 1;
  }

  private calcTreeState() {
    if (this.isPublishedStatus(this.curationStatus) || this.readOnlyUserMode || !this.isCurationItemAssignedToCurrentUser) {
      this._bpmnState = PathwaysAuthoringState.readonly;
    } else if (this.statusChangedToRevise || this.isCurrentStateIsRevise()) {
      this._bpmnState = PathwaysAuthoringState.inReview;
    } else if (this.isEditableStatus(this.curationStatus) && (this.revisionCount === 1)) {
      this._bpmnState = PathwaysAuthoringState.new;
    } else {
      this._bpmnState = PathwaysAuthoringState.readonly;
    }
  }

  private reloadModelerComponent(afterReassign : boolean = false) {
    if (afterReassign || (this.previousStatus && !(this.curationStatus === this.previousStatus))) {
      this.visible = false;
      setTimeout(() => {
        this.visible = true;
        this.detector.markForCheck();
      }, 500);
    }
  }

  private appendDataToRevisedRelatedEntitiesTable(revisedTreatmentsNodeData, node) {
    if (revisedTreatmentsNodeData && revisedTreatmentsNodeData.length > 0) {
      const row = {data: [], relateObject: node};
      this.revisiedEntitiesTableData.rowData.forEach(rowData => {
        if (rowData.source === 'node') {
          row.data.push(get(node, rowData.path));
        }
        if (rowData.source === 'treatmentData') {
          row.data.push(get(revisedTreatmentsNodeData[0], rowData.path));
        }
      });
      this.revisiedEntitiesTableData.rows.push(row);
    }
  }

  private getTreatmentPlansData() {
    const NodescurationInfo = this.content && this.content['bpmn'] ? (this.content['bpmn'].nodes || []) : [];
    let treatmentDataArr: any[];
    const treatmentPlansNodes = values(NodescurationInfo)
      .filter(node => {
        return get(node, 'type', null) === NodeType.treatment && !!get(node, 'data', null);
      })
      .map(treatmentNode => treatmentNode.data['treatmentPlans']);
    treatmentDataArr = flatten(treatmentPlansNodes)
      .map(item => {
        return {treatmentPlan: item.treatmentPlan};
      });
    return treatmentDataArr;
  }

  private isApprovedOrPublishSubmitted(status: string) {
    return status === CurationSettings.CURATION_STATUS_WAITING_FOR_APPROVAL || status === CurationSettings.CURATION_STATUS_PUBLISHED_SUBMITTED;
  }

  protected unsavedChangesExist(userAction: boolean = false): Observable<boolean> {
    return this.nodePanelConfigurationService.handleUnsavedChanges()
  }

  onTreeViewCommand(event) {
    switch (event.command) {
      case 'Close':
        this.treeViewPanelService.closePanel();
        break;
      case 'ChangeExpand':
        this.explorerViewIsInExpandedState = get(event,'state', false);
        this.explorerViewNodeStateMap.clear();
        break;
      case 'NodeExpanded':
        this.setNodeState(event.nodeId, event.expanded);
        break;
      default:
        this.nodeSelectClicked(event);
        break;
    }
  }

  nodeSelectClicked(event: any) {
    if (event && event.selectedNode.data.id) {
      this.selectedNodeId = event.selectedNode.data.id;
      this.latestSelectionSource = CurationNodeSelectionSource.explorerView;
      const data = this.calculateShiftData(event);
      this.store$.dispatch(new NavigateToNodeWithData({
        nodeId: this.selectedNodeId,
        openPanel: false,
        data: data
      }));
    }
  }

  private calculateShiftData(event: any) {
    const data = event.selectedNode.leaf ? this.nodesPlaceViewCalculationsService.calculateShiftData(false)
        : (!event.selectedNode.parent ? {
          X: this.nodesPlaceViewCalculationsService.getXOffsetForHeadNode(this.nodesPlaceViewCalculationsService.shiftFromRightPanel),
          Y: 0, shift: 'fromRightWithOffset'
        } : { X: 0, Y: 0, shift: undefined});
    return data;
  }

  explorerViewDisplayStatusChanged(display: boolean) {
    this.explorerViewIsVisible = display;
    this.nodesPlaceViewCalculationsService.updateRightPanelWidth();
  }

  onRightPanelOpened(display: boolean) {
    if (display) {
      this.nodesPlaceViewCalculationsService.updateRightPanelWidth();
    }
    this.nodesPlaceViewCalculationsService.setRightPanelState(display);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.nodesPlaceViewCalculationsService.updateRightPanelWidth();
  }

  private setNodeState(nodeId: string, expanded: boolean) {
    this.explorerViewNodeStateMap.set(nodeId, expanded);
  }

  private validateContent(status: string) {
    if (this.isBeforeApprovePublish(status)) {
      const nodesCurationInfo = this.content && this.content['bpmn'] ? (this.content['bpmn'].nodes || []) : [];
      let logMessage: string = '';
      values(nodesCurationInfo)
        .forEach(node => {
          if (get(node, 'type', null) !== NodeType.head && get(node, 'type', null) !== NodeType.treatment) {
            const parentNodeIds = get(node, 'parentNodeIds');
            if (parentNodeIds === undefined || (Array.isArray(parentNodeIds) && parentNodeIds.length === 0)) {
              logMessage = logMessage.concat('node ' + node.id + ' has undefined or empty parent nodes, ');
            }
          }
        });
      if (logMessage.length > 0) {
        this.logService.warning('PathwayBpmn: ' + this.curationData['content']['pathwayBpmnName']
          + ', disease: ' + this.curationData['content']['disease']['display']
          + ', revision: ' + this.curationData['revisionName']
          + ', curationdataId : ' + this.curationData['id']
          + ' , message:  ' + logMessage, '');
      }
    }
  }
}
